export default __webpack_public_path__ + "static/media/diary.4a020f1e.png";